/**
 * Однократный лог окружения overlay-страницы. Полезен для диагностики,
 * когда overlay открывается в OBS Browser Source: DevTools там обычно
 * недоступны, но лог пишется через `console.info` и его видно, если
 * ЯВНО подключить удалённую CEF-инспекцию:
 *
 *   1) Запустить OBS с флагом `--remote-debugging-port=9222`.
 *   2) В любом Chromium открыть http://localhost:9222 и выбрать нужный источник.
 *
 * Дополнительно фиксируем:
 *   • window.obsstudio.pluginVersion  — версия плагина Browser Source в OBS.
 *   • navigator.userAgent             — включает Chromium x.y.z (можно сравнить
 *                                       с caniuse Ed25519 Chromium 137+).
 *   • crypto.subtle доступен?         — sanity check secure context.
 */

interface ObsStudioApi {
  pluginVersion?: string
}

interface WindowWithObs extends Window {
  obsstudio?: ObsStudioApi
}

let logged = false

export function logOverlayEnvironment(): void {
  if (logged) return
  logged = true

  const w = window as WindowWithObs
  const obsVersion = w.obsstudio?.pluginVersion
  const inObs = typeof w.obsstudio !== 'undefined'
  const ua = navigator.userAgent
  const hasSubtle = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined'

  // eslint-disable-next-line no-console
  console.info('[overlay] environment', {
    inObs,
    obsBrowserPluginVersion: obsVersion ?? 'n/a',
    userAgent: ua,
    hasSubtleCrypto: hasSubtle,
    origin: window.location.origin,
    pathname: window.location.pathname,
  })
}
